
type Props = {
    logo: {
        id: number;
        title: string;
        img: string;
    };
};

function Brands({ logo }: Props) {
    return (
        <div className="h-full w-[150px] xl:w-[200px] m-2 bg-secondBlack p-5 rounded-md content-center">
            <img
                src={logo.img}
                alt={logo.title}
                className="h-18 w-auto" 
            />
        </div>
    )
}

export default Brands